import React, { useContext, useEffect, useState } from 'react';
import { Col, Card, Navbar, Nav } from "react-bootstrap";
import { FaArrowLeft } from "react-icons/fa";
import axios from 'axios';
import { site_url } from "../config.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import { useLocation } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import { parseStoredAccessToken } from '../parseStoredAccessToken.js';

function Index() {
  const { user } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [totalExpired, setTotalExpired] = useState(0);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const backdrops = document.querySelectorAll(".modal-backdrop");
    backdrops.forEach((el) => el.remove());
    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  }, [location]);

  const goBack = () => {
    window.history.back();
  };

  useEffect(() => {
    getExpiredTransactions();
  }, [user]);

  const getExpiredTransactions = async () => {
    const token = parseStoredAccessToken(user);
    if (!token) {
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const res = await axios.get(site_url + "/customer/expired-transactions", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      });

      if (res.data.status === 'success') {
        setData(res.data.data || []);
        setTotalExpired(parseFloat(res.data.total_expired || 0));
      }
    } catch (err) {
      console.error("API Error:", err?.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-vh-100">
      <Navbar expand="lg" className="navbar px-3">
        <Navbar.Brand className="fw-bold text-white">
          <center>
            <FaArrowLeft onClick={goBack} className="fs-5 text-white notificaton-icon" /> Expired Points
          </center>
        </Navbar.Brand>
        <Nav className="ms-auto d-flex align-items-center" />
      </Navbar>

      <div className="p-3">
        <Card className="mb-3 expired-summary-card">
          <Card.Body className="text-center text-white">
            <div style={{ fontSize: '13px', opacity: 0.9 }}>Total Points Expired</div>
            <div style={{ fontSize: '28px', fontWeight: 'bold', marginTop: '6px' }}>
              🪙 {totalExpired.toFixed(2)}
            </div>
          </Card.Body>
        </Card>

        {loading && (
          <div className="text-center py-4 text-muted">Loading expired transactions...</div>
        )}

        {!loading && data.length === 0 && (
          <div className="text-center py-4 text-muted">No expired transactions found.</div>
        )}

        {!loading && data.map((item) => (
          <div className="col-12 p-1" key={item.id}>
            <Col xs={12}>
              <Card>
                <Card.Body>
                  <div className="row">
                    <div className="col-4">
                      <center><img src={'./wallet.png'} className="shoplist_img" alt="" /></center>
                    </div>
                    <div className="col-8">
                      <h3><span className="shoplist_text">🪙 {parseFloat(item.amount || 0).toFixed(2)}</span></h3>
                      <p className="shoplist_dcr">Type: {item.bonus_type}</p>
                      <p className="shoplist_dcr">Expired on: {item.expired_at}</p>
                      <p className="shoplist_dcr">Recorded: {item.created_at}</p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Index;
